export const CLEAR_GROUP_CONTENT = 'app/Group/CLEAR_GROUP_CONTENT'

export const GET_GROUP_CONTENT = 'app/Group/GET_GROUP_CONTENT'
export const GET_GROUP_CONTENT_DONE = 'app/Group/GET_GROUP_CONTENT_DONE'
export const GET_GROUP_CONTENT_ERROR = 'app/Group/GET_GROUP_CONTENT_ERROR'

export const REMOVE_PINS = 'app/Group/REMOVE_PINS'
export const REMOVE_PINS_DONE = 'app/Group/REMOVE_PINS_DONE'
export const REMOVE_PINS_ERROR = 'app/Group/REMOVE_PINS_ERROR'

// ADD_PINS_TO_GROUP
export const ADD_PINS_TO_GROUP = 'app/Group/ADD_PINS_TO_GROUP'
export const ADD_PINS_TO_GROUP_DONE = 'app/Group/ADD_PINS_TO_GROUP_DONE'
export const ADD_PINS_TO_GROUP_ERROR = 'app/Group/ADD_PINS_TO_GROUP_ERROR'

export const ADD_PINS_TO_GROUPS = 'app/Group/ADD_PINS_TO_GROUPS'

export const SET_GROUP_CONTENT_PARAMS = 'app/Group/SET_GROUP_CONTENT_PARAMS'

export const quickFilterOptions = {
  ALL_PINS: 'Any',
  CREATED_BY_ME: 'ByMe',
  CREATED_BY_OTHERS: 'ByOthers'
}

export const stateFilterOptions = {
  ALL: 'All',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}

export const groupContentSortOptions = {
  NUMBER: 'Number',
  TITLE: 'Title',
  CATEGORY: 'Category',
  PLAN: 'Plan',
  CREATED: 'Created',
  LAST_MODIFIED: 'LastModified',
  STATE: 'State'
}

export const groupContentSortDirectionOptions = {
  ASC: 'ASC',
  DESC: 'DESC'
}

export const groupContentPageSizeOptions = [25, 50, 100]

export const groupContentDefaults = {
  search: '',
  quickFilter: quickFilterOptions.ALL_PINS,
  stateFilter: stateFilterOptions.ACTIVE,
  sort: groupContentSortOptions.TITLE,
  direction: groupContentSortDirectionOptions.DESC,
  page: 0,
  size: groupContentPageSizeOptions[0]
}
